import axios from '@/libs/api.request'
// import baseAxios from 'axios'

let userType = sessionStorage.getItem('ut')

// 获取语言
// export const getDefaultLanguage = (ip) => {
//   return baseAxios.request({
//     url: '/proxy/service/getIpInfo.php',
//     params: {
//       ip
//     },
//     method: 'get'
//   })
// }


// 账号登录
// 发送短信验证码
export const getVerificationCode = (data) => {
  return axios.request({
    url: '/app/getVerificationCode',
    data: {
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1,
      ...data
    },
    method: 'post'
  })
}

// 客户登录
export const login = (data) => {
  return axios.request({
    url: '/app/login',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1,
      ...data
    },
    method: 'post'
  })
}

/** 临时客户注册 */
export const simpleRegister = (data) => {
  return axios.request({
    url: '/app/simpleRegister',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1,
      ...data
    },
    method: 'post'
  })
}

// 客户注册
export const register = (data) => {
  return axios.request({
    url: '/app/register',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1,
      ...data
    },
    method: 'post'
  })
}

// 客户修改密码
export const updatePassword = (data) => {
  return axios.request({
    url: '/app/updatePwd',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1,
      ...data
    },
    method: 'post'
  })
}

// 客户登出
export const logout = (data) => {
  return axios.request({
    url: '/app/logout',
    data,
    method: 'post'
  })
}

// 小烟设备相关
// 获取客户当前小烟设备列表
export const getCurrentEuipmentList = (data) => {
  return axios.request({
    url: '/app/equipment/currentList',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 获取客户当前小烟设备列表(返回带总条数)
export const getCurrentEuipmentListWithTotal = (data) => {
  return axios.request({
    url: '/app/equipment/currentListWithTotal',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 获取客户当前小烟设备列表(包括移除和未移除)
export const getCurrentAllList = (data) => {
  return axios.request({
    url: '/app/equipment/currentAllList',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 获取客户当前小烟设备列表
export const getFavoriteEuipmentList = (data) => {
  return axios.request({
    url: '/app/equipment/favoriteList',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 修改设备挡位
export const editGears = (data) => {
  return axios.request({
    url: '/app/equipment/editGears',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 获取客户当前小烟设备列表
export const getAllEuipmentList = (data) => {
  return axios.request({
    url: '/app/equipment/allList',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 获取设备详情
export const getEuipmentDetail = (data) => {
  return axios.request({
    url: '/app/equipment/getEquipmentDetailById',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 获取烟弹信息
export const getCartridgesDetail = (data) => {
  return axios.request({
    url: '/app/equipment/getCartridgesInfo',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 绑定设备
export const addEuipment = (data) => {
  return axios.request({
    url: '/app/equipment/add',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 置顶设备
export const setStickEuipment = (data) => {
  return axios.request({
    url: '/app/equipment/setStick',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 隐藏设备
export const hideEuipment = (data) => {
  return axios.request({
    url: '/app/equipment/editIsRemove',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 清除设备记录
export const clearEuipmentInfo = (data) => {
  return axios.request({
    url: '/app/equipment/clearProductEquipmentInfo',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 移除设备
export const removeEuipment = (data) => {
  return axios.request({
    url: '/app/equipment/equipmentSolutions',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 设置设备为喜欢/不喜欢
export const editEquipmentLike = (data) => {
  return axios.request({
    url: '/app/equipment/editIsLike',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 设置烟弹为客户喜欢或不喜欢
export const editCartridgesLike = (data) => {
  return axios.request({
    url: '/app/equipment/editIsLikeCartridges',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 抽烟记录相关
// 保存设备抽烟记录
export const addSmoking = (data) => {
  return axios.request({
    url: '/app/smoking/add',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 保存离线的设备抽烟记录
export const addOtherNew = (data) => {
  return axios.request({
    url: '/app/smoking/addOtherNew',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 客户按天/周的抽烟统计
export const personSmokingStats = (data) => {
  return axios.request({
    url: '/app/smoking/personSmokingStats',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}
// 客户抽烟明细信息
export const personSmokingStatsDetail = () => {
  return axios.request({
    url: '/app/smoking/personSmokingStatsDetail',
    method: 'post'
  })
}
// 客户今日抽烟统计
export const personTodaySmokingStats = () => {
  return axios.request({
    url: '/app/smoking/personTodaySmokingStats',
    method: 'post'
  })
}
// 下载客户统计海报
export const statsPoster = () => {
  return axios.request({
    url: '/app/smoking/statsPoster',
    method: 'post'
  })
}

// 顾客详情
export const customerInfo = () => {
  return axios.request({
    url: '/app/customers',
    method: 'post'
  })
}

// 修改顾客
export const editCustomerInfo = (data) => {
  return axios.request({
    url: '/app/customers/edit',
    data,
    method: 'post'
  })
}

// 修改顾客头像
export const editCustomerHead = (data) => {
  let formData = new FormData()
  formData.append('file', data)
  return axios.request({
    url: '/app/customers/editHeadPortrait',
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // },
    data: formData,
    method: 'post'
  })
}

// 帮助中心
// 获取帮助中心列表
export const getHelpList = () => {
  return axios.request({
    url: '/app/helpCentre/list',
    method: 'post'
  })
}

// 获取帮助中心详细信息
export const getHelpDetail = (id) => {
  return axios.request({
    url: '/app/helpCentre/' + id,
    method: 'post'
  })
}

// 获取 说明书列表
export const getSynopsisList = (data) => {
  return axios.request({
    url: '/app/synopsis/list',
    method: 'post',
    data: data
  })
}

// 获取 说明书详细HTML
export const getSynopsisHTML = (id) => {
  return axios.request({
    url: '/app/synopsis/Document/' + id,
    method: 'post'
  })
}

// 防窥接口
export const toFeedback = (data) => {
  return axios.request({
    url: '/app/toGiveBack',
    data,
    method: 'post'
  })
}

// 活动接口
// 查询活动列表
export const getPromotionList = (data) => {
  return axios.request({
    url: '/app/promotions/list',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}
// 对用户回馈作出的回复列表
export const getReplyList = (data) => {
  return axios.request({
    url: '/app/replyForTheGiveBack/list',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// 获取信息详情
export const getPromotionDetail = (id) => {
  return axios.request({
    url: '/app/promotions/' + id,
    method: 'post'
  })
}

// 获取《对用户反馈做出的回复》详情
export const getReplyDetailHTML = (id) => {
  return axios.request({
    url: '/app/replyForTheGiveBack/Document/' + id,
    method: 'post'
  })
}


// 获取版本号
export const getVersion = (data) => {
  return axios.request({
    url: '/app/appVersion/getVersionLast',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}

// app字典
export const getArea = () => {
  return axios.request({
    url: '/app/dict',
    method: 'post'
  })
}

// 获取所有站点
export const getListAllRecoverySite = (data) => {
  return axios.request({
    url: '/app/site/findRecoverySites',
    data: {
      ... data,
      language: sessionStorage.getItem('lang') === 'zh' ? 2 : 1
    },
    method: 'post'
  })
}
